module.exports = __webpack_public_path__ + "img/contents_hospital@2x.c16510ec.png";